import { Card, Page, VerticalStack } from "@shopify/polaris";
import styled from "styled-components";
import { CustomerSearch } from "./components/Search";
import { CustomerTable } from "./components/Table";
import { CustomerTablePagination } from "./components/Pagination";
import { PageActions } from "./components/PageActions";
import { CustomerListProvider } from "./context/CustomerListContext";

const TablePageWrapper = styled.div`
  > .Polaris-Page {
    max-width: max(64rem, 75%);
  }

  .Polaris-IndexTable {
    background: white;
  }
`;

const NavigationContainer = styled.div`
  display: flex;
  gap: 10px;
  padding: 15px;
  background: white;

  > div:first-of-type {
    flex: 1;
  }
`;

const CustomerListContent = () => {
  return (
    <TablePageWrapper>
      <Page title="Customers" primaryAction={<PageActions />}>
        <Card>
          <VerticalStack gap="400">
            <NavigationContainer>
              <CustomerSearch />
            </NavigationContainer>
            <CustomerTable />
            <div style={{ padding: "16px", background: "var(--p-color-bg-subdued)" }}>
              <CustomerTablePagination />
            </div>
          </VerticalStack>
        </Card>
      </Page>
    </TablePageWrapper>
  );
};

export const CustomerList = () => {
  return (
    <CustomerListProvider>
      <CustomerListContent />
    </CustomerListProvider>
  );
};
